/**
 * 副企業管理者登録
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    InputLabel,
    InputBase,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
    Button,
    FormControl,
    FormHelperText,
    MenuItem,
    IconButton,
    SvgIcon,
    DialogTitle,
    Select,
    Tooltip
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {
    dictionary,
    EnterpriseLogin,
    getEnterpriseDetail,
    getlangId,
    getUserInfo,
    getPermissions
} from 'mdoc/admin/axios'
import * as config from 'mdoc/admin/axios/config'
import { messageFormat } from 'mdoc/utils';
import schema from 'async-validator';
import Dialog from 'mdoc/utils/myDialog';
import Toast from 'mdoc/utils/toast';
import $ from 'jquery';
import { getCategoryCmb } from 'mdoc/admin/axios'

const BootstrapInput = withStyles(theme => ({
    root: {
      'label + &': {
        marginTop: theme.spacing.unit * 3,
      },
      width:'130px'
    },
    input: {
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 12,
      padding: '5px 6px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }))(InputBase);


const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapSelect: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da!important',
        paddingLeft: '5px'
    },
    bootstrapFormLabel: {
        lineHeight: '30px'
    },
    bootstrapFormRadioLabel: {
        lineHeight: '30px'
    },
    Radio: {
        padding: '0px 10px'
    },
    buttonlogin: {
        marginLeft: '380px',
        marginTop: '40px',
    },
    buttoncancel: {
        marginLeft: '30px',
        marginTop: '40px',
    },
    required: {
        color: '#F72D2D'
    },
    title: {
        marginLeft: '-20px'
    },
    button:{
        padding:'2px'
    }
});

function MinusIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M19,13H5V11H19V13Z" />
        </SvgIcon>
    );
}
class AssociateEnterprise_Edit extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        // loading: false,
        dictWord: {
            'associate_enterprise_managers_id': '',
            'contact_person_name': '',
            'email': '',
            'tel_no': '',
            'user_generate': '',
            'department_management_auth': '',
            'category_management_auth': '',
            'notification_release': '',
            'push_notice': '',
            'content_registration_auth': '',
            'device_control': '',
            'registration': '',
            'cancel': '',
            'contact_category': '',
            'msg_error_record_exists': '',
            'msg_error_not_null_with_item': '',
            'msg_warning_associate_mgmt_information': '',
            'yes': '',
            'confirmation': '',
            'valid': '',
            'invalid': '',
            'msg_please_enter_halfwidth': '',
            'msg_please_enter_halfwidth_num': '',
            'msg_error_over_length_with_item': '',
            'msg_not_valid_mail_address': '',
            'msg_please_enter_halfwidth_en_num': '',
            'set_lang': '',
            'msg_error_value_invalid': ''
        },
        formData: {
            associateEnterpriseManagersId: {
                value: '',
                error: false,
                errorMsg: '',
                disabled: false
            },
            contactPersonName: {
                value: '',
                error: false,
                errorMsg: ''
            },
            email: {
                value: '',
                error: false,
                errorMsg: '',
                oldValue: '',
            },
            langId: {
                width: '',
                value: '',
            },
            telNo: {
                value: '',
                error: false,
                errorMsg: ''
            },
            userGenerate: {
                ruleId: config['RULE_CODE']['userCreate'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            departmentManagementAuth: {
                ruleId: config['RULE_CODE']['departmentManagementAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            categoryManagementAuth: {
                ruleId: config['RULE_CODE']['categoryManagementAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            newsRelease: {
                ruleId: config['RULE_CODE']['newsRelease'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            pushNotice: {
                ruleId: config['RULE_CODE']['pushNotice'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            contentRegistrationAuth: {
                ruleId: config['RULE_CODE']['contentRegistrationAuth'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            deviceControl: {
                ruleId: config['RULE_CODE']['deviceControl'],
                value: '1',
                error: false,
                errorMsg: ''
            },
            category: {
                width: '',
                value: [{
                    categoryId: '',
                    categoryName: '',
                }],
                error: false,
                errorMsg: ''
            }
        },
        dialogOpen: false,
        categoryList: [''],
        categoryData: null,
        langIdData: [],
        disabledAll: false
    };
    componentWillMount() {
        this.start(this.state);
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        if (!permissions.includes(1)) {
            this.setState({
                disabledAll: true
            });
        }
    }

    componentDidMount() {
        let formData = this.state.formData;
        let width = parseInt(($('#associateEnterpriseManagersId').css('width')).replace('px', '')) / 2
        formData['category'] = Object.assign(this.state['formData']['category'], { width: width + 'px' });
        formData['langId'] = Object.assign(this.state['formData']['langId']);
        this.setState({
            formData: formData
        });
    }
    sortArray(id, oldData) {
        let newsArray = [];
        let j = 0;
        ParentArry(id);
        function ParentArry(id) {
            for (let i in oldData) {
                if (oldData[i].parentId === id) {
                    newsArray[j] = oldData[i];
                    j++;
                    ParentArry(oldData[i].categoryId, newsArray, j);
                }
            }
        }
        return newsArray;
    }
    start = (state) => {
        // this.setState({loading: true});
        //文言
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue
            }
            this.setState({
                dictWord: dict,
            })
        })
        getlangId().then(res => {
            let langIdData = this.state.langIdData
            let data = res.results;
            for (let key in data) {
                let val = data[key];
                langIdData.push({
                    name: val.name,
                    id: val.id
                })
            }
            this.setState({
                langIdData: langIdData,
            })
        })
        //get detail
        if (this.props.match.params.adminId !== undefined) {
            let adminId = this.props.match.params.adminId;
            this.setState({
                loading: true,
            });
            getEnterpriseDetail({
                adminId: adminId,
                'roleId': '2',
            }).then(res => {
                const detail = res.results;
                let formData = this.state.formData;
                for (let index in formData) {
                    let formValue = formData[index];
                    if (formValue['ruleId'] !== undefined) {
                        let vaildFlgList = detail['vaildFlgList'];
                        for (let listKey in vaildFlgList) {
                            let listValue = vaildFlgList[listKey];
                            if (listValue['docTblAdminUserRulePK']['ruleId'] === formValue['ruleId']) {
                                formData[index] = Object.assign(this.state['formData'][index], { value: String(listValue['validFlg']) });
                                break;
                            }
                        }
                    }
                }
                let associateEnterpriseManagersId = Object.assign(this.state['formData']['associateEnterpriseManagersId'], {
                    value: detail['adminUserCode'],
                    disabled: true
                });
                formData['associateEnterpriseManagersId'] = associateEnterpriseManagersId;
                let contactPersonName = Object.assign(this.state['formData']['contactPersonName'], { value: detail['name'] });
                formData['contactPersonName'] = contactPersonName;
                let email = Object.assign(this.state['formData']['email'], { value: detail['email'], oldValue: detail['email'] });
                formData['email'] = email;
                let langId = Object.assign(this.state['formData']['langId'], { value: detail['langId'] });
                formData['langId'] = langId;
                let telNo = Object.assign(this.state['formData']['telNo'], { value: detail['phone'] });
                formData['telNo'] = telNo;
                detail['categoryNameList'] = detail['categoryNameList'].length > 0 ? detail['categoryNameList'] : [{
                    categoryId: '',
                    categoryName: '',
                }];
                let categoryList = [];
                for (let key in detail['categoryNameList']) {
                    categoryList.push(key);
                }
                let category = Object.assign(this.state['formData']['category'], { value: detail['categoryNameList'] });
                formData['category'] = category;
                this.setState({
                    loading: false,
                    formData: formData,
                    categoryList: categoryList.length < 1 ? [''] : categoryList
                });
            }).catch(error => {
                Toast.error(error)
            })
        }
        //get category
        getCategoryCmb().then(res => {
            let results = this.sortArray(0, res.results);
            this.setState({
                // categoryData:res.results!==undefined?res.results:[],
                categoryData: results,
            })
        })
    }


    handleChange = (filed, categoryNum) => event => {
        let formData = this.state.formData;
        if (filed === 'category') {
            let isSame = false;
            for (var key in formData['category']['value']) {
                let value = formData['category']['value'][key]
                if (value['categoryId'] === event.target.value) {
                    isSame = true;
                    break;
                }
            }

            let categoryOld = $.extend({}, this.state.formData.category.value, true);
            if (categoryOld[categoryNum] && categoryOld[categoryNum]['categoryId'] === event.target.value) {
                isSame = false;
            }

            if (isSame) {
                Toast.info(messageFormat(this.state.dictWord.msg_error_record_exists, this.state.dictWord.contact_category));
            } else {
                let category = formData.category.value;
                category[categoryNum] = {
                    categoryId: event.target.value
                }
                formData[filed] = Object.assign(this.state['formData'][filed], { value: category });
            }
        } else {
            formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        }
        this.setState({
            formData: formData
        });
    };
    handleSubmit = () => {
        let descriptor = {
            associateEnterpriseManagersId: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.associate_enterprise_managers_id)
                },
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_en_num, this.state.dictWord.associate_enterprise_managers_id),
                    validator(rule, value, callback, source, options) {
                        if (!/^[0-9a-zA-Z_/.-]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
                {
                    max: 32,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.associate_enterprise_managers_id)
                },
            ],
            contactPersonName: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_person_name)
                },
                {
                    max: 100,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.contact_person_name)
                },
            ],
            email: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.email)
                },
                { type: "email", required: true, message: this.state.dictWord.msg_not_valid_mail_address },
                {
                    max: 50,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.email)
                },
            ],
            langId: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.set_lang) },
            ],
            telNo: [
                {
                    max: 40,
                    message: messageFormat(this.state.dictWord.msg_error_over_length_with_item, this.state.dictWord.tel_no)
                },
                {
                    required: false,
                    message: messageFormat(this.state.dictWord.msg_please_enter_halfwidth_num, this.state.dictWord.tel_no),
                    validator(rule, value, callback, source, options) {
                        if ($.trim(value).length > 0 && !/^[0-9-/]+$/.test(value)) {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                },
            ],
            category: [
                {
                    required: true,
                    message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.contact_category),
                    validator(rule, value, callback, source, options) {
                        if (value[0]['categoryId'] === '') {
                            callback(new Error(rule.message));
                        } else {
                            callback();
                        }
                    }
                }
            ],
        }
        const validator = new schema(descriptor);
        let resourceData = {};
        const formData = this.state.formData;
        for (let index in formData) {
            let item = formData[index];
            let value = item.value;
            resourceData[index] = value;
        }
        
        validator.validate(resourceData, {
            firstFields: true
        }, (errors, fields) => {
            let formData = this.state.formData;
            let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
            let emojierr = [];
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
                let value = formData[index].value;
                if (value && typeof value !== 'object' && value.length > 0) {
                    if (value.search(emojiReg) >= 0) {
                        emojierr.push({ 'message': this.state.dictWord.msg_error_value_invalid, 'field': index });
                    }
                }
            }
            if (errors || emojierr.length > 0) {
                if (errors) {
                    errors.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                if (emojierr.length > 0) {
                    emojierr.forEach(item => {
                        formData[item.field] = Object.assign(this.state['formData'][item.field], {
                            errorMsg: item.message,
                            error: true
                        })
                    });
                }
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    dialogOpen: true,
                    formData: formData
                });
            }
        })
    }
    dialogHandleOK = () => {
        const confirmData = this.state.formData;
        // const categoryList = this.state.categoryList;
        let category = confirmData.category.value
        let categoryData = [];
        for (var key in category) {
            let categoryValue = category[key]
            if (categoryValue['categoryId'] !== '') {
                // categoryData.push(categoryValue)
                categoryData.push({
                    categoryId: categoryValue['categoryId'],
                    // categoryName:categoryValue['categoryName'],
                    sortKey: key,
                })

            }
        }
        let type = 'post';
        if (this.props.match.params.adminId !== undefined) {
            type = 'put';
        }
        EnterpriseLogin({
            'roleId': 2,
            'adminUserCode': confirmData['associateEnterpriseManagersId']['value'],
            'adminId': this.props.match.params.adminId !== undefined ? this.props.match.params.adminId : '',
            'name': confirmData['contactPersonName']['value'],
            'email': confirmData['email']['value'],
            'langId': confirmData['langId']['value'],
            'phone': confirmData['telNo']['value'],
            vaildFlgList: [
                {
                    "ruleId": 3,
                    "validFlg": confirmData['userGenerate']['value']
                }, {
                    "ruleId": 4,
                    "validFlg": confirmData['departmentManagementAuth']['value']
                }, {
                    "ruleId": 5,
                    "validFlg": confirmData['categoryManagementAuth']['value']
                }, {
                    "ruleId": 6,
                    "validFlg": confirmData['newsRelease']['value']
                }, {
                    "ruleId": 7,
                    "validFlg": confirmData['pushNotice']['value']
                }, {
                    "ruleId": 8,
                    "validFlg": confirmData['contentRegistrationAuth']['value']
                }, {
                    "ruleId": 9,
                    "validFlg": confirmData['deviceControl']['value']
                }, {
                    "ruleId": 10,
                    "validFlg": getUserInfo().contentMultipleRegistration
                }, {
                    "ruleId": 25,
                    "validFlg": getUserInfo().applicationImport
                },
                {
                    "ruleId": 26,
                    "validFlg": getUserInfo().activeDirectory
                },
                {
                    "ruleId": 27,
                    "validFlg": getUserInfo().pushDelivery
                },
                {
                    "ruleId": 28,
                    "validFlg": getUserInfo().mailDelivery
                }
            ],
            categoryNameList: categoryData
        }, type).then(res => {
            if(getUserInfo().userId === parseInt(this.props.match.params.adminId)){
                window.localStorage.setItem('localeId', parseInt(confirmData['langId']['value']));
            }
            this.props.history.push('/admin/management/associateEnterprise');
        }).catch(function (error) {
            Toast.error(error);
        })

    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }
    handleCategorySel = (j) => event => {
        this.setState({ categorySel: j })
    }
    handleAddCategory = () => {
        let categoryList = this.state.categoryList;
        let formData = this.state.formData;
        let categoryValue = formData.category.value;
        categoryValue.push({
            categoryId: '',
            categoryName: '',
        })
        categoryList.push('');
        let category = Object.assign(this.state['formData']['category'], { value: categoryValue });
        formData['category'] = category;
        this.setState({
            formData: formData,
            categoryList: categoryList
        });
    }
    handleMinusCategory = (i) => (event) => {
        let categoryList = this.state.categoryList;
        let formData = this.state.formData;
        let categoryValue = formData.category.value;
        categoryValue.splice(i, 1);
        categoryList.splice(i, 1);
        let category = Object.assign(this.state['formData']['category'], { value: categoryValue });
        formData['category'] = category;
        this.setState({
            formData: formData,
            categoryList: categoryList
        });
    }

    render() {
        const { classes } = this.props;
        const { dictWord, categoryList, categoryData, formData } = this.state;
        return (
            <div className="mainDom" style={{minWidth: '700px'}}>
                <div className={classes.appBarSpacer} />
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="associateEnterpriseManagersId">
                            {dictWord.associate_enterprise_managers_id}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.associateEnterpriseManagersId.error} fullWidth>
                            <InputBase
                                id="associateEnterpriseManagersId"
                                value={this.state.formData.associateEnterpriseManagersId.value}
                                fullWidth
                                onChange={this.handleChange('associateEnterpriseManagersId')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.associateEnterpriseManagersId.error}
                                disabled={this.state.formData.associateEnterpriseManagersId.disabled}
                            />
                            {this.state.formData.associateEnterpriseManagersId.error ? <FormHelperText id="associateEnterpriseManagersId-error-text">{this.state.formData.associateEnterpriseManagersId.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="contactPersonName">
                            {dictWord.contact_person_name}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.contactPersonName.error} fullWidth>
                            <InputBase
                                id="contactPersonName"
                                value={this.state.formData.contactPersonName.value}
                                fullWidth
                                onChange={this.handleChange('contactPersonName')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.contactPersonName.error}
                                disabled={this.state.disabledAll}
                            />
                            {this.state.formData.contactPersonName.error ? <FormHelperText id="contactPersonName-error-text">{this.state.formData.contactPersonName.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="email">
                            {dictWord.email}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.email.error} fullWidth>
                            <InputBase
                                id="email"
                                value={this.state.formData.email.value}
                                fullWidth
                                onChange={this.handleChange('email')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.email.error}
                                disabled={this.state.disabledAll}
                            />
                            {this.state.formData.email.error ? <FormHelperText id="email-error-text">{this.state.formData.email.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="langId">
                            {dictWord.set_lang}<span className={classes.required}>*</span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl error={this.state.formData.langId.error} fullWidth>
                            <Select
                                value={this.state.formData.langId.value}
                                onChange={this.handleChange('langId')}
                                id="langId"
                                name="langId"
                                input={<BootstrapInput />}
                            >
                                <MenuItem value="" />
                                {this.state.langIdData.map((item, index) => {
                                    return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                })}
                            </Select>
                            {this.state.formData.langId.error ? <FormHelperText id="langId-error-text">{this.state.formData.langId.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="telNo">
                            {dictWord.tel_no}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FormControl error={this.state.formData.telNo.error} fullWidth>
                            <InputBase
                                id="telNo"
                                value={this.state.formData.telNo.value}
                                fullWidth
                                onChange={this.handleChange('telNo')}
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.telNo.error}
                                disabled={this.state.disabledAll}
                            />
                            {this.state.formData.telNo.error ? <FormHelperText id="telNo-error-text">{this.state.formData.telNo.errorMsg}</FormHelperText> : ''}
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.user_generate}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.userGenerate.value}
                            onChange={this.handleChange('userGenerate')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
					<Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.department_management_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.departmentManagementAuth.value}
                            onChange={this.handleChange('departmentManagementAuth')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.category_management_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.categoryManagementAuth.value}
                            onChange={this.handleChange('categoryManagementAuth')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
					<Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.notification_release}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.newsRelease.value}
                            onChange={this.handleChange('newsRelease')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.push_notice}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.pushNotice.value}
                            onChange={this.handleChange('pushNotice')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
					<Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.content_registration_auth}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.contentRegistrationAuth.value}
                            onChange={this.handleChange('contentRegistrationAuth')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                <Grid container className={classes.margin}>
                    <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                        <InputLabel shrink htmlFor="bootstrap-input">
                            {dictWord.device_control}
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.formData.deviceControl.value}
                            onChange={this.handleChange('deviceControl')}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.valid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio className={classes.Radio} name="test" color="primary" />}
                                label={dictWord.invalid}
                                labelPlacement="end"
                                disabled={this.state.disabledAll}
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
                {categoryList.map((item, i) => {
                    return <Grid key={i} container className={classes.margin}>
                        <Grid item xs={12} md={2} className={classes.bootstrapFormLabel}>
                            <InputLabel shrink htmlFor="bootstrap-input">
                                {dictWord.contact_category + (i + 1)}{i === 0 ? <span className={classes.required}>*</span> : null}
                                {(i + 1) === categoryList.length ? <IconButton color="primary" size="small" className={classes.button} component="span" onClick={this.handleAddCategory} disabled={this.state.disabledAll} >
                                    <AddIcon />
                                </IconButton> : null}
                                {(i !== 0) ? <IconButton color="primary" size="small" className={classes.button} component="span" onClick={this.handleMinusCategory(i)} disabled={this.state.disabledAll} >
                                    <MinusIcon />
                                </IconButton> : null}
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl error={this.state.formData.category.error} fullWidth>
                                <Select
                                    value={formData.category.value[i]['categoryId']}
                                    onChange={this.handleChange('category', i)}
                                    inputProps={{
                                        name: 'category',
                                    }}
                                    input={<BootstrapInput />}
                                    style={{ width: this.state.formData.category.width, position: 'relative' }}
                                    disabled={this.state.disabledAll}
                                >
                                    {categoryData ? categoryData.map((item, j) => {
                                        return <MenuItem key={j} value={item.categoryId}>
                                            <Tooltip placement="bottom-start" disableFocusListener title={item.categoryName}><span style={{ marginLeft: 30 * (item.depth - 1) }}>{item.categoryName}</span></Tooltip></MenuItem>
                                    }) : null}
                                </Select>
                                {this.state.formData.category.error ? <FormHelperText id="category-error-text">{this.state.formData.category.errorMsg}</FormHelperText> : ''}
                            </FormControl>
                        </Grid>
                    </Grid>
                })}

                <Grid container className={classes.margin}>
                    {this.state.disabledAll ? null : <Typography variant="h5" gutterBottom className={classes.buttonlogin}>
                        <Button variant="contained" color="primary" className={classes.label} onClick={this.handleSubmit}>
                            {dictWord.registration}
                        </Button>
                    </Typography>}
                    <Typography variant="h5" gutterBottom className={this.state.disabledAll ? classes.buttonlogin : null}>
                            <Button href={'/admin.html#/admin/management/associateEnterprise'} variant="contained" color="primary" className={classes.buttoncancel}>
                                {dictWord.cancel}
                            </Button>
                    </Typography>
                </Grid>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_warning_associate_mgmt_information']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

AssociateEnterprise_Edit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AssociateEnterprise_Edit);